<template>
    <Wrapper>
        <Topbar button="goBack" logo="buybox" step="1/2" />
        <h2 class="text-center mb-3">{{ $t('header') }}</h2>
        <p class="text-center mb-4">{{ $t('description') }}</p>
        <FormAddWebsite @next="$router.push({ name: 'EntryPageBuyBoxAccountReady' })" />
    </Wrapper>
</template>



<script>
    import Wrapper from '../../parts/Wrapper.vue';
    import Topbar from '../../parts/Topbar.vue';
    import FormAddWebsite from '../../parts/FormAddWebsite.vue';

    export default {
        name: 'AddWebsite',
        components: {
            Wrapper,
            Topbar,
            FormAddWebsite,
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "header": "Podaj dane swojej strony lub profilu social media",
    "description": "Super! Afiliacja to świetny wybór. Teraz daj nam znać, gdzie będziesz korzystać z naszych narzędzi – dodaj swój profil w mediach społecznościowych lub stronę internetową (blog, serwis)."
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "header": "Provide data of your website or social media profile",
    "description": "Super! Affiliation is a great choice. Now let us know where you will use our tools - add your social media profile or website (blog, service)."
}
</i18n>
